import { useDisclosure } from '@chakra-ui/react';
import { ReportingShellNavigatorService } from './shellNavigatorInterface';
import { ShellNavigatorControllerProps } from './shellNavigatorProps';
import useLocalStorageState from 'use-local-storage-state';
import { LocalStorageKeys } from '../../../../../config';

export function createNavigatorService(): ReportingShellNavigatorService {
    return {
        useProps(context, props): ShellNavigatorControllerProps {
            // Use local storage hook directly instead of accessing from props
            const [isOpen, setIsOpen] = useLocalStorageState(
                LocalStorageKeys.INSERT_OVERLAY_STATE,
                {
                    defaultValue: false,
                }
            );

            return {
                disclosure: {
                    insert: useDisclosure({
                        isOpen,
                        onOpen() {
                            setIsOpen(true);
                        },
                        onClose() {
                            setIsOpen(false);
                        },
                    }),
                },
            };
        },
    };
}
